// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const POST_DELETED_BY_ADMIN = "Pr\u00edspevok bol odstr\u00e1nen\u00fd, preto\u017ee poru\u0161oval K\u00f3dex str\u00e1nky, pr\u00edpadne na \u017eiados\u0165 autora.";
export const POST_DELETED_BY_AUTHOR = "Pr\u00edspevok zmazan\u00fd autorom";
export const POST_DELETED_BY_MODERATOR = "Pr\u00edspevok zmazan\u00fd moder\u00e1torkou";
